import { DownloadButton } from "@ugitgud/legos/ui/form/button/DownloadButton";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscDownloadFill } from "@ugitgud/legos/ui/icon/SVG/MiscDownloadFill";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";

export const NEW_APP_BANNER_CTA = "app-new-ugg";

interface NewAppBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function NewAppBanner(props: NewAppBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        "w-full h-[48px] bg-[#0F1923] flex justify-end relative overflow-hidden border-b border-b-[#1E3246]",
        className,
      )}
    >
      <div
        className={classNames(
          "relative h-[48px] w-[1516px] shrink-0",
          "bg-no-repeat bg-contain",
          "[background-image:url('https://static.bigbrain.gg/assets/ugg/cta/new-banner-app-image.png')]",
          "[background-position:calc(100%+135px)_center]",
          "sm:[background-position:calc(50%+500px)_center]",
          "md:[background-position:calc(50%+450px)_center]",
          "lg:[background-position:calc(50%+400px)_center]",
          "xl:[background-position:calc(50%+150px)_center]",
          "2xl:[background-position:calc(50%+200px)_center]",
        )}
        style={{ aspectRatio: "379/12" }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[1]"
        style={{
          background: "linear-gradient(90deg, #0F1822 0%, rgba(15,24,34,0.00) 75.79%)",
        }}
      />
      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-between sm:justify-center gap-3 sm:gap-4 md:gap-6 px-4 sm:px-6 md:px-8 text-white",
          { "pr-10": onClose },
        )}
      >
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)]">
          <div className="uppercase font-barlow-condensed font-bold text-[18px] leading-[18px] text-left">
            <span className="xs:hidden">The Brand New U.GG App</span>
            <span className="hidden xs:inline">Introducing the Brand New U.GG App</span>
          </div>
          <div className="font-inter font-medium text-[11px] leading-[14px] opacity-90 hidden xs:block text-center sm:text-left">
            Switch between LoL &amp; Valorant in one free, seamless experience
          </div>
        </div>

        <DownloadButton
          href={`${href}?utm_source=topbanner`}
          onClick={onUrlClick}
          className="p-2 sm:px-3 sm:py-2 space-x-2 sm:space-x-3 flex items-center"
        >
          <Icon icon={<SvgMiscDownloadFill />} size="custom" className="w-4 h-4 sm:w-4.5 sm:h-4.5" />
          <div className="text-[12px] sm:text-[13px] font-bold">Download Now</div>
        </DownloadButton>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
